import { useContextSelector } from 'use-context-selector';

import ApiResponseContext from '../ApiProvider/ApiProviderContext';

function useGetTravelerProfileResponse() {
  return useContextSelector(ApiResponseContext, (state) => state.traveler);
}

export default useGetTravelerProfileResponse;
